<template>
  <div 
    class="ProductShippingResume"
    :class="isZeborne ? 'zeborne' : 'mcp'"
  >
    
    <!-- Price -->
    <div class="ProductShippingResume-choice-price" :class="{'renting': isAvailableForRenting || isAvailableForFinancing}">
      
      <div class="ProductShippingResume-wrapper normal-price-wrapper">  
        <input 
          type="radio" 
          v-model="methodPaymentModel" 
          @change="changeMethodPayment" 
          id="normal-price" 
          name="price-choice" 
          value="retail" 
          v-if="isAvailableForRenting || isAvailableForFinancing"
        >
        <label for="normal-price" v-if="isAvailableForRenting || isAvailableForFinancing"></label>
        
        <div class="ProductShippingResume-price">

          <div class="ProductShippingResume-value">
            <div class="ProductShippingResume-title">
              <p>Total <span v-if="reducedTaxRate == originalTva || productBillInfo.tva == originalTva">TVA {{ productBillInfo.tva }}%</span></p>
            </div>
            <CartPrice
              v-if="productCurrentTva"
              :originalPrice="originalPrice"
              :specialPrice="specialPrice"
              :ecoTaxe="productBillInfo.ecoTaxe"
              :devider="devider"
              :specialPriceTotal="getOriginalSpecialPrice()"
              :isProductPage="fromProductPage"
            ></CartPrice>
            <div class="mobileOnly">
              <PaymentLogo></PaymentLogo>
            </div>
          </div>
          
          <div class="PaymentChoice">
            <ul class="Modal-Installments">
              <li v-for="(installmentsValue, index) in fullInstallments" :key="index">
                <button
                        class="Button Button-installments"
                        :data-devider="installmentsValue"
                        @click="updateInstallments"
                        @click.prevent="modifyPrice"
                        :id="installmentsValue"
                        :class="{ selected: indexSelect === installmentsValue }"
                >
                  {{ installmentsValue }}X<span>CB</span>
                </button>
              </li>
            </ul>
            <div class="desktopOnly">
              <PaymentLogo></PaymentLogo>
            </div>
          </div>
          
        </div>
        
      </div>
      
      <div v-show="isAvailableForRenting || isAvailableForFinancing" class="or desktopOnly">
        ou
      </div>

      <div v-show="isAvailableForRenting" class="ProductShippingResume-wrapper">
        <input type="radio" id="renting-price" v-model="methodPaymentModel" @change="changeMethodPayment" name="price-choice" value="renting">
        <label for="renting-price"></label>
        <div class="ProductShippingResume-title">
          <p>Prix ZElocation <span>TVA {{ tvaProfils.high_rate }}%</span></p>
        </div>
        <div class="ProductShippingResume-price">
          <div class="ProductShippingResume-value">
            <div class="CartPrice">
              <div class="CartPrice-container">
                <p class="priceBig">
                  <span :inner-html.prop="rentingPriceSelected | formatPrice(2)"></span>
                  <span> / mois</span>
                </p>
                <label for="select-months">Nombre de mois</label>
                <select name="months" id="select-months" v-model="selectedMonthsModel" @change="changeSelectPrice">
                  <option value="2">{{ isAvailableForRenting ? rentingPrice.price_including_tax.months_2.nb_months : ''}}</option>
                  <option value="1">{{ isAvailableForRenting ? rentingPrice.price_including_tax.months_1.nb_months : ''}}</option>
                  <option value="0">{{ isAvailableForRenting ? rentingPrice.price_including_tax.months_0.nb_months : ''}}</option>
                </select>
                <a @click.prevent="openModalRenting" class="more">En savoir plus</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="isAvailableForRenting && isAvailableForFinancing" class="or desktopOnly">
        ou
      </div>

      <div v-show="isAvailableForFinancing" class="ProductShippingResume-wrapper">
        <input type="radio" id="financing-price" v-model="methodPaymentModel" @change="changeMethodPayment" name="price-choice" value="financing">
        <label for="financing-price"></label>
        <div class="ProductShippingResume-title">
          <p>Financement</p>
        </div>
        <div class="ProductShippingResume-price">
          <div class="ProductShippingResume-value">
            <div class="CartPrice">
              <div class="CartPrice-container">
                <p class="priceBig">
                  <span :inner-html.prop="financingPriceSelected | formatPrice(2)"></span>
                  <span> / mois</span>
                </p>
                <p v-if="isAvailableForFinancing && financingPrice.price_including_tax['months_'+selectedMonthsFinancingModel]">
                  <label>TAEG global: {{ isAvailableForFinancing ? financingPrice.price_including_tax['months_'+selectedMonthsFinancingModel].annual_percentage_rate.replace('.', ',') : ''}}%</label>
                </p>
                <label for="select-months">Nombre de mois</label>
                <select 
                  v-model="selectedMonthsFinancingModel"
                  name="months" 
                  id="select-months-financing"
                  @change="changeSelectPrice" 
                  :disabled="isPac"
                >
                  <option v-if="isAvailableForFinancing && financingPrice.price_including_tax.months_1 !== undefined" value="1">{{ financingPrice.price_including_tax.months_1.nb_months }}</option>
                  <option v-if="isAvailableForFinancing && financingPrice.price_including_tax.months_0 !== undefined" value="0">{{ financingPrice.price_including_tax.months_0.nb_months }}</option>
                </select>
                <a @click.prevent="openModalFinancing" class="more">En savoir plus</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- LOGO -->
    <div class="ProductShippingResume-logo"></div>

    <!-- SUBMIT -->
    <div class="ProductShippingResume-submit" :class="isZeborne ? '' : 'desktopOnly'">
      <ButtonProduct></ButtonProduct>
    </div>

    <!-- REASSURANCE -->
    <div class="ProductShippingResume-reassurance">
      <ul>
        <li class="cancel"><span>Annulation gratuite</span></li>
        <li class="divider"></li>
        <li class="monitoring"><span>Suivi des travaux</span></li>
        <li class="divider"></li>
        <li class="satisfied"><span>Qualifié RGE</span></li>
      </ul>
    </div>

    <transition name="slide-fade">
      <component
        :is="modalCalendarComponent"
        v-if="showModalCalendar"
        :showModal="showModalCalendar"
        :class="'Modal-right'"
        @Modal::close="closeModalCalendar"
        :rentingLayer="rentingLayer"
        :financingLayer="financingLayer"
      />
    </transition>
  </div>
</template>

<script>
import CartPrice from "@/includes/Cart/CartPrice/CartPrice.vue";
import PaymentLogo from "@/components/Payment/PaymentLogo/PaymentLogo.vue";
//import ModalInstallments from "@/components/Modal/ModalInstallments.vue";
import ButtonProduct from "@/components/ButtonProduct/ButtonProduct.vue";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import EventBus from "@/event-bus";
import installmentsMixins from "@/mixins/installmentsMixin.js";

import "@/includes/Product/ProductShippingResume/ProductShippingResume.scss";

const ModalCalendar = () => import(/* webpackChunkName: "modal-calendar" */ '@/components/Modal/ModalCalendar.vue');
const ModalCalendarZeborne = () => import(/* webpackChunkName: "modal-calendar-zeborne" */ '@/components/Modal/zeborne/ModalCalendar.vue');

export default {
  name: "ProductShippingResume",

  mixins: [installmentsMixins],

  components: {
    CartPrice,
    PaymentLogo,
    ButtonProduct,
  },

  data () {
    return {
      showModal: false,
      tva: false,
      devider: 3,
      schedules: {},
      indexSelect: 3,
      selectedMonthsModel: "0",
      selectedMonthsFinancingModel: "0",
      rentingPriceSelected: "",
      financingPriceSelected: "",
      rentingLayer: false,
      financingLayer: false,
      showModalCalendar: false,
      isRentingModel: false,
      methodPaymentModel: 'retail',
     modalCalendarComponent: () => ({
        component: ModalCalendar()
      }),
    };
  },

  props: {
    originalPrice: { String, Number },
    specialPrice: { String, Number },
    fromProductPage: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    isTaxReducible (newValue) {
      if (newValue === true) {
        this.tva = true;
        this.setAppProductParticularTva(this.reducedTaxRate);
      }
    },

    isRenting() {
      if(this.isZeborne && this.isRenting) {
        this.getPreviousCartRentingInfo()
      }
    },
  },

  methods: {
    ...mapActions(["setAppProductParticularTva", "setAppProductOriginalTva", "setPreprendCartRentingNbMonths","setPreprendCartFinancingNbMonths", "setPreprendCartIsRenting","setPreprendCartIsFinancing","setPreprendCartCurrentSelectedDelivery"]),

    getOriginalSpecialPrice() {
      return this.productBillInfo.specialPrice[this.productCurrentTva] + this.additionalInfo;
    },

    openModal () {
      this.showModal = true;
    },
    closeModal () {
      this.showModal = false;
    },
    openModalRenting () {
      this.showModalCalendar = true;
      this.rentingLayer = true;
      this.financingLayer = false;
    },
    openModalFinancing () {
      this.showModalCalendar = true;
      this.financingLayer = true;
      this.rentingLayer = false;

    },
    closeModalCalendar () {
      this.showModalCalendar = false;
    },

    changeMethodPayment () {
      this.setPreprendCartIsRenting((this.methodPaymentModel == 'renting') ? true : false);
      this.setPreprendCartIsFinancing((this.methodPaymentModel == 'financing') ? true : false);
      if(this.methodPaymentModel == 'renting') {
        this.setPreprendCartCurrentSelectedDelivery('delivery_and_installation');
      }
    },

    modifyPrice () {
      if(!this.isPac) {
        this.devider = this.indexSelect;
      }
      
      this.schedules = this.productSchedule[this.productCurrentTva][this.devider];
      if( this.devider > 1){
        this.specialPrice = this.schedules[0].amount;
        this.originalPrice = this.productBillInfo.originalPrice[this.productCurrentTva];
      } 
      else {
        this.specialPrice = this.productBillInfo.specialPrice[this.productCurrentTva] + this.additionalInfo;
        this.originalPrice = this.productBillInfo.originalPrice[this.productCurrentTva];
      }
    },

    changeSelectPrice () {
      var monthKey = "months_"+this.selectedMonthsModel;
      var monthKeyFinancing = "months_"+this.selectedMonthsFinancingModel;

      this.rentingPriceSelected = this.isAvailableForRenting ? this.rentingPrice.price_including_tax[monthKey].final_price : null;
      this.financingPriceSelected = this.isAvailableForFinancing ? this.financingPrice.price_including_tax[monthKeyFinancing][this.productCurrentTva].final_price : null;

      this.setPreprendCartRentingNbMonths(this.selectedMonthsModel);
      this.setPreprendCartFinancingNbMonths(this.selectedMonthsFinancingModel);
    },

    loadRentingAndFinancing () {

      if(this.isAvailableForRenting){
        this.selectedMonthsModel = this.selectedMonthsRenting;
      }

      if(this.isAvailableForFinancing){
        if(this.financingPrice.price_including_tax['months_'+this.selectedMonthsFinancing]){
          this.selectedMonthsFinancingModel = this.selectedMonthsFinancing;
        }else{
          this.selectedMonthsFinancingModel = Object.keys(this.financingPrice.price_including_tax)[0].replace('months_', '');
        }
      }

      if(this.isRenting){
        this.methodPaymentModel = 'renting';
      }else if(this.isFinancing){
        this.methodPaymentModel = 'financing';
      }else{
        this.methodPaymentModel = 'retail';
      }
    },

    scrollTo (event) {
      EventBus.$emit("action-scroll", event);
    },

    setMethodPaymentModel(){
      if(this.isRenting){
        this.methodPaymentModel = 'renting';
      }else if(this.isFinancing){
        this.methodPaymentModel = 'financing';
      }else{
        this.methodPaymentModel = 'retail';
      }
    },

    getNbRentingMonthInCart() {
      for (const [key, value] of Object.entries(this.rentingPrice.price_including_tax)) {
        if(value.nb_months === this.selectedMonthsRenting  ) {
          this.selectedMonthsModel = key.split('_')[1]
        }
      }
    },

    getPreviousCartRentingInfo() {
      this.methodPaymentModel = "renting";
      this.getNbRentingMonthInCart();
      this.changeSelectPrice()
    }
  },

  computed: {
    ...mapGetters({
      productBillInfo: "getProductBillInfo",
      productCurrentTva: "getProductTVAForCurrentDelivery",
      isTaxReducible: "isProductTaxReducible",
      additionalInfo: "getPreprendCartAdditionalInfo",
      productSchedule: "getProductSchedule",
      isAvailableForRenting: "getProductAvailableForRenting",
      isAvailableForFinancing: "getProductAvailableForFinancing",
      rentingPrice: "getProductRentingPrice",
      financingPrice: "getProductFinancingPrice",
      selectedMonthsRenting: "getPreprendCartRentingNbMonths",
      selectedMonthsFinancing: "getPreprendCartFinancingNbMonths",
      isRenting: "getPreprendCartIsRenting",
      isFinancing: "getPreprendCartIsFinancing",
      currentSelectedDelivery: "getPreprendCartCurrentSelectedDelivery",
      rateTaxDeliveryClassic: "getAppProductRateTaxDeliveryClassic",
      isZeborne: "isZeborne",
      isPac: "isPac",
      originalTva: "getProductOriginalTVA",
      reducedTaxRate: "getProductReducedTaxRate",
      isLead: "isLead",
      isAvailableForRenting: "getProductAvailableForRenting",
      isAvailableForFinancing: "getProductAvailableForFinancing",
      tvaProfils: "getTvaProfils",
    }),
  },

  created() {
    if (this.isZeborne === true && !this.isLead) {
      this.modalCalendarComponent = () => ({
        component: ModalCalendarZeborne()
      });
    }
  },

  mounted () {

    if(!this.isPac) {
      try {
        if (localStorage.getItem("devider") !== null) {
          this.devider = localStorage.getItem("devider");
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      this.devider = 1;
    }

    this.loadRentingAndFinancing();
    this.modifyPrice();
    this.changeSelectPrice();

    EventBus.$on("update-price-cart", () => this.modifyPrice());
  },

  updated() {
    this.loadRentingAndFinancing();
    this.modifyPrice();
    this.changeSelectPrice();
  },
};
</script>
